import Page from "../common/page/Page"
import style from "./Policies.module.css"

const AboutUs = () => {
  return (
    <Page title="About Us" searchDisabled={true}>
      <div className={style.policyContainer}>
        {/* Luxury Hero Banner */}
        <div className={style.heroHeader}>
          <h1>About Us</h1>
          <p className={style.heroSubtitle}>
            Learn more about Dr. Malu Mahendran’s manufacturing unit & commitment to natural health.
          </p>
        </div>

        {/* Content Card */}
        <div className={style.sectionCard}>
          <h2>About Us</h2>

          <p>
            <strong>Dr. Malu Mahendran's</strong>
            <br />
            Manufacturing Unit
            <br />
            T. V Puram P. O<br />
            Kottayam, Kerala
          </p>

          <h3>Contact</h3>
          <p>
            Email:{" "}
            <a href="mailto:drmmherbalsenquiry@gmail.com">
              drmmherbalsenquiry@gmail.com
            </a>
          </p>
        </div>
      </div>
    </Page>
  )
}

export default AboutUs
